module.exports = __webpack_public_path__ + "static/media/investigative_large.0a36a415.jpg";